export interface ApiResponse<T> {
  data: T;
  meta?: { total?: number; page?: number; pageSize?: number };
}

export interface ApiError {
  error: string;
  details?: string[];
  statusCode?: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: { total: number; page: number; pageSize: number; cost_summary?: { total_products: number; products_with_cost: number; products_without_cost: number } };
}

export function toPaginatedResponse<T>(response: { data: T[]; meta?: Record<string, unknown> }, page: number, pageSize: number): PaginatedResponse<T> {
  return {
    data: response.data,
    meta: {
      total: Number(response.meta?.total ?? response.data.length),
      page: Number(response.meta?.page ?? page),
      pageSize: Number(response.meta?.pageSize ?? pageSize),
      ...(response.meta?.cost_summary ? { cost_summary: response.meta.cost_summary as { total_products: number; products_with_cost: number; products_without_cost: number } } : {}),
    },
  };
}

